function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _toPropertyKey from "@babel/runtime/helpers/esm/toPropertyKey";
import _extends from "@babel/runtime/helpers/esm/extends";
var _excluded = [
    "id",
    "field"
], _excluded2 = [
    "id",
    "field"
];
import * as React from 'react';
import { unstable_useEventCallback as useEventCallback, unstable_useEnhancedEffect as useEnhancedEffect } from '@mui/utils';
import { warnOnce } from '@mui/x-internals/warning';
import { useGridApiEventHandler, useGridApiOptionHandler } from "../../utils/useGridApiEventHandler.js";
import { GridEditModes, GridCellModes } from "../../../models/gridEditRowModel.js";
import { useGridApiMethod } from "../../utils/useGridApiMethod.js";
import { gridEditRowsStateSelector } from "./gridEditingSelectors.js";
import { isPrintableKey, isPasteShortcut } from "../../../utils/keyboardUtils.js";
import { gridRowsLookupSelector } from "../rows/gridRowsSelector.js";
import { deepClone } from "../../../utils/utils.js";
import { GridCellEditStartReasons, GridCellEditStopReasons } from "../../../models/params/gridEditCellParams.js";
import { getDefaultCellValue } from "./utils.js";
export var useGridCellEditing = function(apiRef, props) {
    var _React_useState = _sliced_to_array(React.useState({}), 2), cellModesModel = _React_useState[0], setCellModesModel = _React_useState[1];
    var cellModesModelRef = React.useRef(cellModesModel);
    var prevCellModesModel = React.useRef({});
    var processRowUpdate = props.processRowUpdate, onProcessRowUpdateError = props.onProcessRowUpdateError, cellModesModelProp = props.cellModesModel, onCellModesModelChange = props.onCellModesModelChange;
    var runIfEditModeIsCell = function(callback) {
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            if (props.editMode === GridEditModes.Cell) {
                callback.apply(void 0, _to_consumable_array(args));
            }
        };
    };
    var throwIfNotEditable = React.useCallback(function(id, field) {
        var params = apiRef.current.getCellParams(id, field);
        if (!apiRef.current.isCellEditable(params)) {
            throw new Error("MUI X: The cell with id=".concat(id, " and field=").concat(field, " is not editable."));
        }
    }, [
        apiRef
    ]);
    var throwIfNotInMode = React.useCallback(function(id, field, mode) {
        if (apiRef.current.getCellMode(id, field) !== mode) {
            throw new Error("MUI X: The cell with id=".concat(id, " and field=").concat(field, " is not in ").concat(mode, " mode."));
        }
    }, [
        apiRef
    ]);
    var handleCellDoubleClick = React.useCallback(function(params, event) {
        if (!params.isEditable) {
            return;
        }
        if (params.cellMode === GridCellModes.Edit) {
            return;
        }
        var newParams = _extends({}, params, {
            reason: GridCellEditStartReasons.cellDoubleClick
        });
        apiRef.current.publishEvent('cellEditStart', newParams, event);
    }, [
        apiRef
    ]);
    var handleCellFocusOut = React.useCallback(function(params, event) {
        if (params.cellMode === GridCellModes.View) {
            return;
        }
        if (apiRef.current.getCellMode(params.id, params.field) === GridCellModes.View) {
            return;
        }
        var newParams = _extends({}, params, {
            reason: GridCellEditStopReasons.cellFocusOut
        });
        apiRef.current.publishEvent('cellEditStop', newParams, event);
    }, [
        apiRef
    ]);
    var handleCellKeyDown = React.useCallback(function(params, event) {
        if (params.cellMode === GridCellModes.Edit) {
            // Wait until IME is settled for Asian languages like Japanese and Chinese
            // TODO: to replace at one point. See https://github.com/mui/material-ui/pull/39713#discussion_r1381678957.
            if (event.which === 229) {
                return;
            }
            var reason;
            if (event.key === 'Escape') {
                reason = GridCellEditStopReasons.escapeKeyDown;
            } else if (event.key === 'Enter') {
                reason = GridCellEditStopReasons.enterKeyDown;
            } else if (event.key === 'Tab') {
                reason = event.shiftKey ? GridCellEditStopReasons.shiftTabKeyDown : GridCellEditStopReasons.tabKeyDown;
                event.preventDefault(); // Prevent going to the next element in the tab sequence
            }
            if (reason) {
                var newParams = _extends({}, params, {
                    reason: reason
                });
                apiRef.current.publishEvent('cellEditStop', newParams, event);
            }
        } else if (params.isEditable) {
            var reason1;
            var canStartEditing = apiRef.current.unstable_applyPipeProcessors('canStartEditing', true, {
                event: event,
                cellParams: params,
                editMode: 'cell'
            });
            if (!canStartEditing) {
                return;
            }
            if (isPrintableKey(event)) {
                reason1 = GridCellEditStartReasons.printableKeyDown;
            } else if (isPasteShortcut(event)) {
                reason1 = GridCellEditStartReasons.pasteKeyDown;
            } else if (event.key === 'Enter') {
                reason1 = GridCellEditStartReasons.enterKeyDown;
            } else if (event.key === 'Backspace' || event.key === 'Delete') {
                reason1 = GridCellEditStartReasons.deleteKeyDown;
            }
            if (reason1) {
                var newParams1 = _extends({}, params, {
                    reason: reason1,
                    key: event.key
                });
                apiRef.current.publishEvent('cellEditStart', newParams1, event);
            }
        }
    }, [
        apiRef
    ]);
    var handleCellEditStart = React.useCallback(function(params) {
        var id = params.id, field = params.field, reason = params.reason;
        var startCellEditModeParams = {
            id: id,
            field: field
        };
        if (reason === GridCellEditStartReasons.printableKeyDown || reason === GridCellEditStartReasons.deleteKeyDown || reason === GridCellEditStartReasons.pasteKeyDown) {
            startCellEditModeParams.deleteValue = true;
        }
        apiRef.current.startCellEditMode(startCellEditModeParams);
    }, [
        apiRef
    ]);
    var handleCellEditStop = React.useCallback(function(params) {
        var id = params.id, field = params.field, reason = params.reason;
        apiRef.current.runPendingEditCellValueMutation(id, field);
        var cellToFocusAfter;
        if (reason === GridCellEditStopReasons.enterKeyDown) {
            cellToFocusAfter = 'below';
        } else if (reason === GridCellEditStopReasons.tabKeyDown) {
            cellToFocusAfter = 'right';
        } else if (reason === GridCellEditStopReasons.shiftTabKeyDown) {
            cellToFocusAfter = 'left';
        }
        var ignoreModifications = reason === 'escapeKeyDown';
        apiRef.current.stopCellEditMode({
            id: id,
            field: field,
            ignoreModifications: ignoreModifications,
            cellToFocusAfter: cellToFocusAfter
        });
    }, [
        apiRef
    ]);
    var runIfNoFieldErrors = function(callback) {
        return /*#__PURE__*/ _async_to_generator(function() {
            var _len, args, _key, _editRowsState_id_field, _args_, id, field, editRowsState, hasFieldErrors;
            var _arguments = arguments;
            return _ts_generator(this, function(_state) {
                for(_len = _arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = _arguments[_key];
                }
                if (callback) {
                    ;
                    _args_ = args[0], id = _args_.id, field = _args_.field;
                    editRowsState = apiRef.current.state.editRows;
                    hasFieldErrors = (_editRowsState_id_field = editRowsState[id][field]) === null || _editRowsState_id_field === void 0 ? void 0 : _editRowsState_id_field.error;
                    if (!hasFieldErrors) {
                        callback.apply(void 0, _to_consumable_array(args));
                    }
                }
                return [
                    2
                ];
            });
        });
    };
    useGridApiEventHandler(apiRef, 'cellDoubleClick', runIfEditModeIsCell(handleCellDoubleClick));
    useGridApiEventHandler(apiRef, 'cellFocusOut', runIfEditModeIsCell(handleCellFocusOut));
    useGridApiEventHandler(apiRef, 'cellKeyDown', runIfEditModeIsCell(handleCellKeyDown));
    useGridApiEventHandler(apiRef, 'cellEditStart', runIfEditModeIsCell(handleCellEditStart));
    useGridApiEventHandler(apiRef, 'cellEditStop', runIfEditModeIsCell(handleCellEditStop));
    useGridApiOptionHandler(apiRef, 'cellEditStart', props.onCellEditStart);
    useGridApiOptionHandler(apiRef, 'cellEditStop', runIfNoFieldErrors(props.onCellEditStop));
    var getCellMode = React.useCallback(function(id, field) {
        var editingState = gridEditRowsStateSelector(apiRef.current.state);
        var isEditing = editingState[id] && editingState[id][field];
        return isEditing ? GridCellModes.Edit : GridCellModes.View;
    }, [
        apiRef
    ]);
    var updateCellModesModel = useEventCallback(function(newModel) {
        var isNewModelDifferentFromProp = newModel !== props.cellModesModel;
        if (onCellModesModelChange && isNewModelDifferentFromProp) {
            onCellModesModelChange(newModel, {
                api: apiRef.current
            });
        }
        if (props.cellModesModel && isNewModelDifferentFromProp) {
            return; // The prop always win
        }
        setCellModesModel(newModel);
        cellModesModelRef.current = newModel;
        apiRef.current.publishEvent('cellModesModelChange', newModel);
    });
    var updateFieldInCellModesModel = React.useCallback(function(id, field, newProps) {
        // We use the ref because it always contain the up-to-date value, different from the state
        // that needs a rerender to reflect the new value
        var newModel = _extends({}, cellModesModelRef.current);
        if (newProps !== null) {
            newModel[id] = _extends({}, newModel[id], _define_property({}, field, _extends({}, newProps)));
        } else {
            var _newModel$id = newModel[id], otherFields = _objectWithoutPropertiesLoose(_newModel$id, [
                field
            ].map(_toPropertyKey)); // Ensure that we have a new object, not a reference
            newModel[id] = otherFields;
            if (Object.keys(newModel[id]).length === 0) {
                delete newModel[id];
            }
        }
        updateCellModesModel(newModel);
    }, [
        updateCellModesModel
    ]);
    var updateOrDeleteFieldState = React.useCallback(function(id, field, newProps) {
        apiRef.current.setState(function(state) {
            var newEditingState = _extends({}, state.editRows);
            if (newProps !== null) {
                newEditingState[id] = _extends({}, newEditingState[id], _define_property({}, field, _extends({}, newProps)));
            } else {
                delete newEditingState[id][field];
                if (Object.keys(newEditingState[id]).length === 0) {
                    delete newEditingState[id];
                }
            }
            return _extends({}, state, {
                editRows: newEditingState
            });
        });
        apiRef.current.forceUpdate();
    }, [
        apiRef
    ]);
    var startCellEditMode = React.useCallback(function(params) {
        var id = params.id, field = params.field, other = _objectWithoutPropertiesLoose(params, _excluded);
        throwIfNotEditable(id, field);
        throwIfNotInMode(id, field, GridCellModes.View);
        updateFieldInCellModesModel(id, field, _extends({
            mode: GridCellModes.Edit
        }, other));
    }, [
        throwIfNotEditable,
        throwIfNotInMode,
        updateFieldInCellModesModel
    ]);
    var updateStateToStartCellEditMode = useEventCallback(/*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(params) {
            var id, field, deleteValue, initialValue, value, newValue, column, shouldProcessEditCellProps, newProps, editingState;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        id = params.id, field = params.field, deleteValue = params.deleteValue, initialValue = params.initialValue;
                        value = apiRef.current.getCellValue(id, field);
                        newValue = value;
                        if (deleteValue) {
                            newValue = getDefaultCellValue(apiRef.current.getColumn(field));
                        } else if (initialValue) {
                            newValue = initialValue;
                        }
                        column = apiRef.current.getColumn(field);
                        shouldProcessEditCellProps = !!column.preProcessEditCellProps && deleteValue;
                        newProps = {
                            value: newValue,
                            error: false,
                            isProcessingProps: shouldProcessEditCellProps
                        };
                        updateOrDeleteFieldState(id, field, newProps);
                        apiRef.current.setCellFocus(id, field);
                        if (!shouldProcessEditCellProps) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            Promise.resolve(column.preProcessEditCellProps({
                                id: id,
                                row: apiRef.current.getRow(id),
                                props: newProps,
                                hasChanged: newValue !== value
                            }))
                        ];
                    case 1:
                        newProps = _state.sent();
                        // Check if still in edit mode before updating
                        if (apiRef.current.getCellMode(id, field) === GridCellModes.Edit) {
                            editingState = gridEditRowsStateSelector(apiRef.current.state);
                            updateOrDeleteFieldState(id, field, _extends({}, newProps, {
                                value: editingState[id][field].value,
                                isProcessingProps: false
                            }));
                        }
                        _state.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        });
        return function(params) {
            return _ref.apply(this, arguments);
        };
    }());
    var stopCellEditMode = React.useCallback(function(params) {
        var id = params.id, field = params.field, other = _objectWithoutPropertiesLoose(params, _excluded2);
        throwIfNotInMode(id, field, GridCellModes.Edit);
        updateFieldInCellModesModel(id, field, _extends({
            mode: GridCellModes.View
        }, other));
    }, [
        throwIfNotInMode,
        updateFieldInCellModesModel
    ]);
    var updateStateToStopCellEditMode = useEventCallback(/*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(params) {
            var id, field, ignoreModifications, _params_cellToFocusAfter, cellToFocusAfter, finishCellEditMode, editingState, _editingState_id_field, error, isProcessingProps, rowUpdate, handleError, row;
            return _ts_generator(this, function(_state) {
                id = params.id, field = params.field, ignoreModifications = params.ignoreModifications, _params_cellToFocusAfter = params.cellToFocusAfter, cellToFocusAfter = _params_cellToFocusAfter === void 0 ? 'none' : _params_cellToFocusAfter;
                throwIfNotInMode(id, field, GridCellModes.Edit);
                apiRef.current.runPendingEditCellValueMutation(id, field);
                finishCellEditMode = function() {
                    updateOrDeleteFieldState(id, field, null);
                    updateFieldInCellModesModel(id, field, null);
                    if (cellToFocusAfter !== 'none') {
                        apiRef.current.moveFocusToRelativeCell(id, field, cellToFocusAfter);
                    }
                };
                if (ignoreModifications) {
                    finishCellEditMode();
                    return [
                        2
                    ];
                }
                editingState = gridEditRowsStateSelector(apiRef.current.state);
                _editingState_id_field = editingState[id][field], error = _editingState_id_field.error, isProcessingProps = _editingState_id_field.isProcessingProps;
                if (error || isProcessingProps) {
                    // Attempt to change cell mode to "view" was not successful
                    // Update previous mode to allow another attempt
                    prevCellModesModel.current[id][field].mode = GridCellModes.Edit;
                    // Revert the mode in the cellModesModel prop back to "edit"
                    updateFieldInCellModesModel(id, field, {
                        mode: GridCellModes.Edit
                    });
                    return [
                        2
                    ];
                }
                rowUpdate = apiRef.current.getRowWithUpdatedValuesFromCellEditing(id, field);
                if (processRowUpdate) {
                    handleError = function(errorThrown) {
                        prevCellModesModel.current[id][field].mode = GridCellModes.Edit;
                        // Revert the mode in the cellModesModel prop back to "edit"
                        updateFieldInCellModesModel(id, field, {
                            mode: GridCellModes.Edit
                        });
                        if (onProcessRowUpdateError) {
                            onProcessRowUpdateError(errorThrown);
                        } else if (process.env.NODE_ENV !== 'production') {
                            warnOnce([
                                'MUI X: A call to `processRowUpdate` threw an error which was not handled because `onProcessRowUpdateError` is missing.',
                                'To handle the error pass a callback to the `onProcessRowUpdateError` prop, for example `<DataGrid onProcessRowUpdateError={(error) => ...} />`.',
                                'For more detail, see https://mui.com/x/react-data-grid/editing/#server-side-persistence.'
                            ], 'error');
                        }
                    };
                    try {
                        row = apiRef.current.getRow(id);
                        Promise.resolve(processRowUpdate(rowUpdate, row, {
                            rowId: id
                        })).then(function(finalRowUpdate) {
                            apiRef.current.updateRows([
                                finalRowUpdate
                            ]);
                            finishCellEditMode();
                        }).catch(handleError);
                    } catch (errorThrown) {
                        handleError(errorThrown);
                    }
                } else {
                    apiRef.current.updateRows([
                        rowUpdate
                    ]);
                    finishCellEditMode();
                }
                return [
                    2
                ];
            });
        });
        return function(params) {
            return _ref.apply(this, arguments);
        };
    }());
    var setCellEditingEditCellValue = React.useCallback(/*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(params) {
            var _editingState_id_field, _editingState_id, id, field, value, debounceMs, skipValueParser, column, row, parsedValue, editingState, newProps, hasChanged;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        id = params.id, field = params.field, value = params.value, debounceMs = params.debounceMs, skipValueParser = params.unstable_skipValueParser;
                        throwIfNotEditable(id, field);
                        throwIfNotInMode(id, field, GridCellModes.Edit);
                        column = apiRef.current.getColumn(field);
                        row = apiRef.current.getRow(id);
                        parsedValue = value;
                        if (column.valueParser && !skipValueParser) {
                            parsedValue = column.valueParser(value, row, column, apiRef);
                        }
                        editingState = gridEditRowsStateSelector(apiRef.current.state);
                        newProps = _extends({}, editingState[id][field], {
                            value: parsedValue,
                            changeReason: debounceMs ? 'debouncedSetEditCellValue' : 'setEditCellValue'
                        });
                        if (!column.preProcessEditCellProps) return [
                            3,
                            2
                        ];
                        hasChanged = value !== editingState[id][field].value;
                        newProps = _extends({}, newProps, {
                            isProcessingProps: true
                        });
                        updateOrDeleteFieldState(id, field, newProps);
                        return [
                            4,
                            Promise.resolve(column.preProcessEditCellProps({
                                id: id,
                                row: row,
                                props: newProps,
                                hasChanged: hasChanged
                            }))
                        ];
                    case 1:
                        newProps = _state.sent();
                        _state.label = 2;
                    case 2:
                        // Check again if the cell is in edit mode because the user may have
                        // discarded the changes while the props were being processed.
                        if (apiRef.current.getCellMode(id, field) === GridCellModes.View) {
                            return [
                                2,
                                false
                            ];
                        }
                        editingState = gridEditRowsStateSelector(apiRef.current.state);
                        newProps = _extends({}, newProps, {
                            isProcessingProps: false
                        });
                        // We don't update the value with the one coming from the props pre-processing
                        // because when the promise resolves it may be already outdated. The only
                        // exception to this rule is when there's no pre-processing.
                        newProps.value = column.preProcessEditCellProps ? editingState[id][field].value : parsedValue;
                        updateOrDeleteFieldState(id, field, newProps);
                        editingState = gridEditRowsStateSelector(apiRef.current.state);
                        return [
                            2,
                            !((_editingState_id = editingState[id]) === null || _editingState_id === void 0 ? void 0 : (_editingState_id_field = _editingState_id[field]) === null || _editingState_id_field === void 0 ? void 0 : _editingState_id_field.error)
                        ];
                }
            });
        });
        return function(params) {
            return _ref.apply(this, arguments);
        };
    }(), [
        apiRef,
        throwIfNotEditable,
        throwIfNotInMode,
        updateOrDeleteFieldState
    ]);
    var getRowWithUpdatedValuesFromCellEditing = React.useCallback(function(id, field) {
        var column = apiRef.current.getColumn(field);
        var editingState = gridEditRowsStateSelector(apiRef.current.state);
        var row = apiRef.current.getRow(id);
        if (!editingState[id] || !editingState[id][field]) {
            return apiRef.current.getRow(id);
        }
        var value = editingState[id][field].value;
        return column.valueSetter ? column.valueSetter(value, row, column, apiRef) : _extends({}, row, _define_property({}, field, value));
    }, [
        apiRef
    ]);
    var editingApi = {
        getCellMode: getCellMode,
        startCellEditMode: startCellEditMode,
        stopCellEditMode: stopCellEditMode
    };
    var editingPrivateApi = {
        setCellEditingEditCellValue: setCellEditingEditCellValue,
        getRowWithUpdatedValuesFromCellEditing: getRowWithUpdatedValuesFromCellEditing
    };
    useGridApiMethod(apiRef, editingApi, 'public');
    useGridApiMethod(apiRef, editingPrivateApi, 'private');
    React.useEffect(function() {
        if (cellModesModelProp) {
            updateCellModesModel(cellModesModelProp);
        }
    }, [
        cellModesModelProp,
        updateCellModesModel
    ]);
    // Run this effect synchronously so that the keyboard event can impact the yet-to-be-rendered input.
    useEnhancedEffect(function() {
        var rowsLookup = gridRowsLookupSelector(apiRef);
        // Update the ref here because updateStateToStopCellEditMode may change it later
        var copyOfPrevCellModes = prevCellModesModel.current;
        prevCellModesModel.current = deepClone(cellModesModel); // Do a deep-clone because the attributes might be changed later
        Object.entries(cellModesModel).forEach(function(param) {
            var _param = _sliced_to_array(param, 2), id = _param[0], fields = _param[1];
            Object.entries(fields).forEach(function(param) {
                var _param = _sliced_to_array(param, 2), field = _param[0], params = _param[1];
                var _copyOfPrevCellModes_id_field, _copyOfPrevCellModes_id;
                var prevMode = ((_copyOfPrevCellModes_id = copyOfPrevCellModes[id]) === null || _copyOfPrevCellModes_id === void 0 ? void 0 : (_copyOfPrevCellModes_id_field = _copyOfPrevCellModes_id[field]) === null || _copyOfPrevCellModes_id_field === void 0 ? void 0 : _copyOfPrevCellModes_id_field.mode) || GridCellModes.View;
                var originalId = rowsLookup[id] ? apiRef.current.getRowId(rowsLookup[id]) : id;
                if (params.mode === GridCellModes.Edit && prevMode === GridCellModes.View) {
                    updateStateToStartCellEditMode(_extends({
                        id: originalId,
                        field: field
                    }, params));
                } else if (params.mode === GridCellModes.View && prevMode === GridCellModes.Edit) {
                    updateStateToStopCellEditMode(_extends({
                        id: originalId,
                        field: field
                    }, params));
                }
            });
        });
    }, [
        apiRef,
        cellModesModel,
        updateStateToStartCellEditMode,
        updateStateToStopCellEditMode
    ]);
};
